import React , {useState} from 'react';
import Button from '../button/Button';
import PropTypes from 'prop-types';

import img from '../../assets/images/layouts/create.png'

Create.propTypes = {
    data: PropTypes.object,
};
Create.dafaultPropTypes={
    data:{
        heading: '',
        desc: '',
        btn:true,
        btnTitle:'Join  Now',
        link:'/contact',
    }
}

function Create(props) {

    const {data} = props;
    return (
        <section className="create">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="create__main">
                                <div className="content">
                                    {data.heading && <h4 className="heading" dangerouslySetInnerHTML={{ __html: data.heading }} />}
                                    {data.heading5 && <h5 className="heading" dangerouslySetInnerHTML={{ __html: data.heading5 }} />}
                                    {data.desc && <p>{data.desc}</p>}
                                    {data.btn && <Button title={data.btnTitle} link={data.link} target={data.target} />}
                                </div>
                                {data.img && (
                                    <img src={data.img} alt="AVRLabs" className='mxw-100' />
                                )}      
                            </div>
                        </div>
                    </div>
                </div>
            </section>
    );
}

export default Create;